import fireb from "../firebase/fireBase"
const db = fireb.firestore()

const savePreviewData = (appid, payload) => {
    const ref = appid ? db.collection('appsPreview').doc(appid) : false

    appid && ref.update(payload)
        .then(() => { })
        .catch(error => {})
}

const previewNavigate = (appid, url) => {
    const ref = appid ? db.collection('appsPreview').doc(appid) : false
    ref.update({ navigate: url })
}

export {
    savePreviewData,
    previewNavigate
}